import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonService } from '../../../services/common.service';
import { Button } from '../../../model/enum';
import { TabsService } from '../../tabs/tabs.service';

@Component({
  selector: 'app-common-summary-tab',
  templateUrl: './common-summary-tab.component.html',
  styleUrls: ['./common-summary-tab.component.scss']
})
export class CommonSummaryTabComponent implements OnInit {
  flexHeight;
  failed = true;
  totalRecords;
  enumButtonName = Button;
 @Output() newImport = new EventEmitter<number>();
 @Input() data:any = {}

  constructor(public commonService: CommonService,public tabsService: TabsService,) { }

  ngOnInit(): void {
    this.commonService.headerHeight.subscribe(res =>{
      this.flexHeight = "calc(100vh - 290px - " + res +"px" + ")" 
  })

  }
  onClick(){
    this.newImport.emit(0)
  }
    header: any[] = [['Company Name', 'Status', 'Notes']];
   bodyData: any[] = [
     ['ABC Industries', 'Success', 'Imported successfully'],
     ['XYZ Suppliers', 'Error', 'Missing required field'],
   ];

   downloadExel(value?: string){
    const headData: any = this.header;
    const bodyData: any = this.bodyData;
    const title: any = value === 'Error' ? 'import-error.xlsx' : 'import-summary.xlsx';
    this.commonService.export(headData, bodyData, title);
   }
}
